import { z } from 'zod';

import { CourseTranslationsSchema } from '../course/course';

/**
 * The editable half of a course.
 *
 * Declared as a raw shape so the update schema can `.partial()` it — the same
 * reason `NotificationTemplateWritableShape` exists.
 *
 * **`sortOrder` is not here.** Ordering is a *relation* between siblings, and a
 * form that lets one row set its own index produces duplicates and gaps the
 * moment two staff save at once. It moves through the reorder endpoint, which
 * names the whole set in one guarded statement (N29's ordered lock).
 */
export const CourseWritableShape = {
  isActive: z.boolean(),
  translations: CourseTranslationsSchema,
};

export const CourseCreateSchema = z.object({ ...CourseWritableShape }).strict();

export type CourseCreateRequest = z.infer<typeof CourseCreateSchema>;
